





























































































































































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { StudentInfo } from "../../_models/studentInfo";
import { TutoreInfo } from "../../_models/tutoreInfo";
import { DocAutorizzazioneInfo } from "../../_models/docAutorizzazioneInfo";
import DocPreviewDialog from "../../components/Dialogs/DocPreviewDialog.vue";
import * as data from "../../_store/data.module";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import { bus } from "../../main";
import { userService } from "../../_services";
import { userUtils } from "../../_utils/userUtils";
// //@ts-ignore
// import * as pdfMake from "pdfmake/build/pdfmake";
// //@ts-ignore
// import * as pdfFonts from 'pdfmake/build/vfs_fonts';

@Component({
  components: {
    DocPreviewDialog
  }
})
export default class AuthorizationPage extends Vue {
  @Prop() idDoc!: number;

  private stati: any;
  private items: any;
  private searchComuneAllievo: object | null;
  private searchComuneTutor: object | null;
  private searchLuogoNascita: object | null;
  private isLoading: boolean;
  private studentInfo: StudentInfo;
  private tutoreData: TutoreInfo;
  private statoNascitaAllievo: string;

  private cognomeRules: [boolean | string];
  private nomeRules: [boolean | string];
  private luogoNascitaRules: [boolean | string];
  private cognomeTutoreRules: [boolean | string];
  private nomeTutoreRules: [boolean | string];
  private indirizzoRules: [boolean | string];
  private tel1Rules: [boolean | string];
  private emailRules: [boolean | string];
  private relazioneParentaleRules: [boolean | string];
  private telefonoTutoreRules: [boolean | string];
  private indirizzoTutoreRules: [boolean | string];
  private comuneTutoreRules: [boolean | string];
  private provinciaTutoreRules: [boolean | string];
  private capTutoreRules: [boolean | string];
  private dataRules: [boolean | string];
  private comuneUtenteRules: [boolean | string];
  private capRules: [boolean | string];

  private idCapTutore: number;

  constructor() {
    super();
    this.studentInfo = {
      tipoSoggetto: 0,
      matricola: "",
      ruoloUtente: [],
      descrizioneRuolo: [],
      nomeUtente: "",
      cognomeUtente: "",
      indirizzoUtente: "",
      telefono1Utente: "",
      telefono2Utente: "",
      cod: "",
      dataNascita: "",
      luogoNascita: "",
      emailUtente: "",
      pecUtente: "",
      comuneUtente: "",
      provinciaUtente: "",
      entità: "",
      codEntità: 0,
      idCap: 0,
      idUtente: 0,
      cap: "",
      username: "",
      classe: "",
      idClasse: 0,
      idNazioneNascita: "",
      diplomato: false,
      dataDiploma: "",
      urlCV: ""
    };
    this.tutoreData = {
      cognomeTutore: "",
      nomeTutore: "",
      relazioneParentale: "",
      indirizzoTutore: "",
      capTutore: "",
      comuneTutore: "",
      provinciaTutore: "",
      telefonoTutore: ""
    };
    this.statoNascitaAllievo = "";

    this.cognomeRules = [true];
    this.nomeRules = [true];
    this.luogoNascitaRules = [true];
    this.cognomeTutoreRules = [true];
    this.nomeTutoreRules = [true];
    this.indirizzoRules = [true];
    this.tel1Rules = [true];
    this.emailRules = [true];
    this.relazioneParentaleRules = [true];
    this.telefonoTutoreRules = [true];
    this.indirizzoTutoreRules = [true];
    this.comuneTutoreRules = [true];
    this.provinciaTutoreRules = [true];
    this.capTutoreRules = [true];
    this.dataRules = [true];
    this.comuneUtenteRules = [true];
    this.capRules = [true];

    this.stati = [];
    this.items = [];
    this.searchComuneAllievo = null;
    this.searchComuneTutor = null;
    this.searchLuogoNascita = null;
    this.isLoading = false;

    this.idCapTutore = 0;
  }

  @Watch("searchComuneAllievo")
  onComuneAllivoChanged(value: string) {
    if (this.items.length > 0) return;
    this.isLoading = true;
    data
      .dispatchComuniList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.items = response;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      })
      .finally(() => (this.isLoading = false));
  }

  @Watch("searchComuneTutor")
  onComuneTutorChanged(value: string) {
    if (this.items.length > 0) return;
    this.isLoading = true;
    data
      .dispatchComuniList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.items = response;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      })
      .finally(() => (this.isLoading = false));
  }

  @Watch("searchLuogoNascita")
  onLuogoNascitaChanged(value: string) {
    if (this.items.length > 0) return;
    this.isLoading = true;
    data
      .dispatchComuniList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.items = response;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      })
      .finally(() => (this.isLoading = false));
  }

  validazioneCognome() {
    var valid: boolean = false;
    if (
      this.studentInfo.cognomeUtente !== "" &&
      this.studentInfo.cognomeUtente !== null
    ) {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(
        this.studentInfo.cognomeUtente
      );
    }
    if (valid) {
      this.cognomeRules = [true];
    } else if (
      this.studentInfo.cognomeUtente === "" ||
      this.studentInfo.cognomeUtente === null
    ) {
      this.cognomeRules = ["Cognome Utente necessario"];
    } else {
      this.cognomeRules = [
        "Cognome Utente deve essere compreso tra i 2 e i 50 caratteri"
      ];
    }
  }
  validazioneNome() {
    var valid: boolean = false;
    if (
      this.studentInfo.nomeUtente !== "" &&
      this.studentInfo.nomeUtente !== null
    ) {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.studentInfo.nomeUtente);
    }
    if (valid) {
      this.nomeRules = [true];
    } else if (
      this.studentInfo.nomeUtente === "" ||
      this.studentInfo.nomeUtente === null
    ) {
      this.nomeRules = ["Nome Utente necessario"];
    } else {
      this.nomeRules = [
        "Nome Utente deve essere compreso tra i 2 e i 50 caratteri"
      ];
    }
  }

  validazioneLuogoNascita() {
    if (
      this.studentInfo.luogoNascita !== "" &&
      this.studentInfo.luogoNascita !== null
    ) {
      this.luogoNascitaRules = [true];
    } else {
      this.luogoNascitaRules = ["Luogo di nascita necessario"];
    }
  }
  validazioneData() {
    var valid: boolean = false;
    if (
      this.studentInfo.dataNascita !== "" &&
      this.studentInfo.dataNascita !== null
    ) {
      valid = /^[0-3]+[0-9]+\/[0-1]+[0-9]+\/[0-9]{4}$/.test(
        this.studentInfo.dataNascita
      );
    }
    if (valid) {
      this.dataRules = [true];
    } else if (
      this.studentInfo.dataNascita === "" ||
      this.studentInfo.dataNascita === null
    ) {
      this.dataRules = ["Data nascita studente necessaria"];
    } else {
      this.dataRules = ["La Data deve essere nel formato gg/mm/aaaa"];
    }
  }
  validazioneComuneUtente() {
    if (this.studentInfo.idCap !== 0 && this.studentInfo.idCap !== null) {
      this.comuneUtenteRules = [true];
    } else {
      this.comuneUtenteRules = ["Comune residenza studente necessario"];
    }
  }
  validazioneEmail() {
    var valid: boolean = false;
    if (
      this.studentInfo.emailUtente !== "" &&
      this.studentInfo.emailUtente !== null
    ) {
      valid = /[a-zA-Z0-9.-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}$/.test(
        this.studentInfo.emailUtente
      );
    }
    if (valid) {
      this.emailRules = [true];
    } else if (
      this.studentInfo.emailUtente === "" ||
      this.studentInfo.emailUtente === null
    ) {
      this.emailRules = ["Email studente necessaria"];
    } else {
      this.emailRules = ["Formato Email non corretto"];
    }
  }
  validazioneTel() {
    var valid: boolean = false;
    if (
      this.studentInfo.telefono1Utente !== "" &&
      this.studentInfo.telefono1Utente !== null
    ) {
      valid = /[0-9]{9,13}$/.test(this.studentInfo.telefono1Utente);
    }

    if (valid) {
      this.tel1Rules = [true];
    } else if (
      this.studentInfo.telefono1Utente === "" ||
      this.studentInfo.telefono1Utente === null
    ) {
      this.tel1Rules = ["Numero telefono studente necessario"];
    } else {
      this.tel1Rules = ["Il numero di telefono non ha un formato corretto"];
    }
  }
  validazioneCap() {
    var valid: boolean = false;
    if (this.studentInfo.cap !== "" && this.studentInfo.cap !== null) {
      valid = /^[0-9]{5}$/.test(this.studentInfo.cap);
    }
    if (valid) {
      this.capRules = [true];
    } else if (this.studentInfo.cap === "" || this.studentInfo.cap === null) {
      this.capRules = ["Cap studente necessario"];
    } else {
      this.capRules = ["Formato Cap errato"];
    }
  }
  validazioneIndirizzo() {
    var valid: boolean = false;
    if (
      this.studentInfo.indirizzoUtente !== "" &&
      this.studentInfo.indirizzoUtente !== null
    ) {
      valid = /^[a-zA-Z00-9ìèéùòà,.'\x20/-]{2,100}$/.test(
        this.studentInfo.indirizzoUtente
      );
    }
    if (valid) {
      this.indirizzoRules = [true];
    } else if (
      this.studentInfo.indirizzoUtente === "" ||
      this.studentInfo.indirizzoUtente === null
    ) {
      this.indirizzoRules = ["Indirizzo studente necessario"];
    } else {
      this.indirizzoRules = [
        "Indirizzo non può avere più di 100 caratteri e non deve contenere caratteri speciali"
      ];
    }
  }

  validazioneCognomeTutore() {
    var valid: boolean = false;
    if (
      this.tutoreData.cognomeTutore !== "" &&
      this.tutoreData.cognomeTutore !== null
    ) {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.tutoreData.cognomeTutore);
    }
    if (valid) {
      this.cognomeTutoreRules = [true];
    } else if (
      this.tutoreData.cognomeTutore === "" ||
      this.tutoreData.cognomeTutore === null
    ) {
      this.cognomeTutoreRules = ["Cognome Utente necessario"];
    } else {
      this.cognomeTutoreRules = [
        "Cognome deve essere compreso tra i 2 e i 50 caratteri e non contenere caratteri speciali o numeri"
      ];
    }
  }
  validazioneNomeTutore() {
    var valid: boolean = false;
    if (
      this.tutoreData.nomeTutore !== "" &&
      this.tutoreData.nomeTutore !== null
    ) {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.tutoreData.nomeTutore);
    }
    if (valid) {
      this.nomeTutoreRules = [true];
    } else if (
      this.tutoreData.nomeTutore === "" ||
      this.tutoreData.nomeTutore === null
    ) {
      this.nomeTutoreRules = ["Nome Utente necessario"];
    } else {
      this.nomeTutoreRules = [
        "Nome deve essere compreso tra i 2 e i 50 caratteri e non contenere caratteri speciali o numeri"
      ];
    }
  }
  validazioneRelazioneParentale() {
    var valid: boolean = false;
    if (
      this.tutoreData.relazioneParentale !== "" &&
      this.tutoreData.relazioneParentale !== null
    ) {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(
        this.tutoreData.relazioneParentale
      );
    }
    if (valid) {
      this.relazioneParentaleRules = [true];
    } else if (
      this.tutoreData.relazioneParentale === "" ||
      this.tutoreData.relazioneParentale === null
    ) {
      this.relazioneParentaleRules = ["Relazione parentale necessaria"];
    } else {
      this.relazioneParentaleRules = [
        "Relazione parentale deve essere compresa tra i 2 e i 50 caratteri e non contenere caratteri speciali o numeri"
      ];
    }
  }
  validazioneTelTutore() {
    var valid: boolean = false;
    if (
      this.tutoreData.telefonoTutore !== "" &&
      this.tutoreData.telefonoTutore !== null
    ) {
      valid = /[0-9]{9,13}$/.test(this.tutoreData.telefonoTutore);
    }

    if (valid) {
      this.telefonoTutoreRules = [true];
    } else if (
      this.tutoreData.telefonoTutore === "" ||
      this.tutoreData.telefonoTutore === null
    ) {
      this.telefonoTutoreRules = ["Numero telefono necessario"];
    } else {
      this.telefonoTutoreRules = [
        "Il numero di telefono non ha un formato corretto"
      ];
    }
  }
  validazioneIndirizzoTutore() {
    var valid: boolean = false;
    if (
      this.tutoreData.indirizzoTutore !== "" &&
      this.tutoreData.indirizzoTutore !== null
    ) {
      valid = /^[a-zA-Z00-9ìèéùòà,'\x20/-]{2,100}$/.test(
        this.tutoreData.indirizzoTutore
      );
    }
    if (valid) {
      this.indirizzoTutoreRules = [true];
    } else if (
      this.tutoreData.indirizzoTutore === "" ||
      this.tutoreData.indirizzoTutore === null
    ) {
      this.indirizzoTutoreRules = ["Indirizzo necessario"];
    } else {
      this.indirizzoTutoreRules = [
        "Indirizzo non può avere più di 100 caratteri e non deve contenere caratteri speciali"
      ];
    }
  }
  validazioneComuneTutore() {
    if (this.idCapTutore !== 0 || this.idCapTutore !== null) {
      this.comuneTutoreRules = [true];
    } else {
      this.comuneTutoreRules = ["Comune esercente patria potestà necessario"];
    }
  }
  validazioneProvinciaTutore() {
    var valid: boolean = false;
    if (
      this.tutoreData.provinciaTutore !== "" &&
      this.tutoreData.provinciaTutore !== null
    ) {
      valid = /^[A-Z]{2}$/.test(this.tutoreData.provinciaTutore);
    }
    if (valid) {
      this.provinciaTutoreRules = [true];
    } else if (
      this.tutoreData.provinciaTutore === "" ||
      this.tutoreData.provinciaTutore === null
    ) {
      this.provinciaTutoreRules = ["Provincia necessaria"];
    } else {
      this.provinciaTutoreRules = [
        "Provincia deve contenere 2 caratteri maiuscoli"
      ];
    }
  }
  validazioneCapTutore() {
    var valid: boolean = false;
    if (
      this.tutoreData.capTutore !== "" &&
      this.tutoreData.capTutore !== null
    ) {
      valid = /^[0-9]{5}$/.test(this.tutoreData.capTutore);
    }
    if (valid) {
      this.capTutoreRules = [true];
    } else if (
      this.tutoreData.capTutore === "" ||
      this.tutoreData.capTutore === null
    ) {
      this.capTutoreRules = ["Cap necessario"];
    } else {
      this.capTutoreRules = ["Formato Cap errato"];
    }
  }

  clearStudentSignature() {
    //@ts-ignore
    this.$refs.studentSignaturePad.clearSignature();
  }

  clearTutoreSignature() {
    //@ts-ignore
    this.$refs.tutoreSignaturePad.clearSignature();
  }

  async executeTest() {
    this.validazioneCognome();
    this.validazioneNome();
    this.validazioneLuogoNascita();
    this.validazioneData();
    this.validazioneIndirizzo();
    this.validazioneComuneUtente();
    this.validazioneCap();
    this.validazioneTel();
    this.validazioneEmail();
    this.validazioneCognomeTutore();
    this.validazioneNomeTutore();
    this.validazioneRelazioneParentale();
    this.validazioneTelTutore();
    this.validazioneIndirizzoTutore();
    this.validazioneComuneTutore();
    this.validazioneProvinciaTutore();
    this.validazioneCapTutore();
  }

  save() {
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        var comuneNomeAllievo: string = "";
        var comuneNomeTutore: string = "";
        var provinciaNomeAllievo: string = "";
        var provinciaNomeTutore: string = "";
        var statoNascitaAllievoNome: string = "";
        var idAllievo: number = this.studentInfo.idUtente;
        var signatureAllievoEmpty: boolean = true;
        var signatureTutoreEmpty: boolean = true;
        //@ts-ignore
        const signatureAllievo = this.$refs.studentSignaturePad.saveSignature();
        //@ts-ignore
        const signatureTutore = this.$refs.tutoreSignaturePad.saveSignature();

        if (
          signatureAllievo.isEmpty === false &&
          signatureTutore.isEmpty === false
        ) {
          var i: number = 0;
          while (comuneNomeAllievo === "" && i < this.items.length) {
            if (this.items[i].id === this.studentInfo.idCap) {
              comuneNomeAllievo = this.items[i].località;
              provinciaNomeAllievo = this.items[i].idProvincia;
            }
            i++;
          }
          i = 0;
          while (comuneNomeTutore === "" && i < this.items.length) {
            if (this.items[i].id === this.idCapTutore) {
              comuneNomeTutore = this.items[i].località;
              provinciaNomeTutore = this.items[i].idProvincia;
            }
            i++;
          }
          i = 0;
          while (statoNascitaAllievoNome === "" && i < this.stati.length) {
            if (this.stati[i].idStato === this.studentInfo.idNazioneNascita) {
              statoNascitaAllievoNome = this.stati[i].nomeStato;
            }
            i++;
          }
          var today = new Date();
          var dd = String(today.getDate()).padStart(2, "0");
          var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
          var yyyy = today.getFullYear();

          var authorizationInfo: DocAutorizzazioneInfo = {
            cognomeAllievo: this.studentInfo.cognomeUtente,
            nomeAllievo: this.studentInfo.nomeUtente,
            luogoNascitaAllievo: this.studentInfo.luogoNascita,
            dataNascitaAllievo: this.studentInfo.dataNascita,
            indirizzoAllievo: this.studentInfo.indirizzoUtente,
            comuneAllievo: comuneNomeAllievo,
            provinciaAllievo: provinciaNomeAllievo,
            capAllievo: this.studentInfo.cap,
            telefonoAllievo: this.studentInfo.telefono1Utente,
            emailAllievo: this.studentInfo.emailUtente,
            classeAllievo: this.studentInfo.classe,
            cognomeTutore: this.tutoreData.cognomeTutore,
            nomeTutore: this.tutoreData.nomeTutore,
            relazioneParentale: this.tutoreData.relazioneParentale,
            telefonoTutore: this.tutoreData.telefonoTutore,
            indirizzoTutore: this.tutoreData.indirizzoTutore,
            comuneTutore: comuneNomeTutore,
            provinciaTutore: provinciaNomeTutore,
            capTutore: this.tutoreData.capTutore,
            firmaAllievo: signatureAllievo.data,
            firmaTutore: signatureTutore.data,
            statoAutorizzazione: 1,
            idDoc: this.idDoc,
            dataDocumento: dd + "/" + mm + "/" + yyyy,
            codiceFiscaleAllievo: this.studentInfo.cod,
            statoNascitaAllievo: statoNascitaAllievoNome
          };
          const payload = {
            info: authorizationInfo,
            docType: "autorizzazioneStudenti",
            idAllievo: idAllievo
          };
          bus.$emit("openDocAutorizzazionePreview", payload);
        }
      }
    });
  }

  back() {
    this["$router"].push("/moduliStudente");
  }

  created() {
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (this.studentInfo.idNazioneNascita === null) {
      this.studentInfo.idNazioneNascita = "086";
    }
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetStudentInfo(this["$store"], payload)
      .then(() => {
        bus.$emit("loadMenu");
        this.studentInfo = user.readStudentInfo(this["$store"]);
        data
          .dispatchComuniList(this["$store"])
          .then(result => {
            // this.items = result;
            var obj = {
              id: 0,
              località: "",
              idProvincia: ""
            };
            result.forEach(element => {
              if (element.id !== 0) {
                obj = {
                  id: element.id,
                  località: element.località,
                  idProvincia: element.idProvincia
                };
                this.items.push(obj);
              }
            });
          })
          .catch(error => {
            bus.$emit(
              "errorOperation",
              "Errore nel caricamento della lista comuni"
            );
          });
        data
          .dispatchStatiList(this["$store"])
          .then(result => {
            var obj = {
              idStato: "",
              nomeStato: ""
            };
            result.forEach(element => {
              obj = {
                idStato: element.idStato,
                nomeStato: element.nomeStato
              };
              this.stati.push(obj);
            });
          })
          .catch(error => {
            bus.$emit(
              "errorOperation",
              "Errore nel caricamento della lista nazioni"
            );
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });
  }
}
